import React from "react";
import styles from "./techStack.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReact, faCss3Alt } from "@fortawesome/free-brands-svg-icons";
import { faCode, faCloud, faTriangleCircleSquare } from "@fortawesome/free-solid-svg-icons";
import LazyText from "../../../common/imagescroll/LazyText";

const TechStack: React.FC = () => {
    const items = [
        {
            icon: faReact,
            title: "React",
            description: "Modern, fast, and perfect for building smooth user experiences.",
            iconColor:  "#74C0FC"
        },
        {
            icon: faCode,
            title: "TypeScript",
            description: "Strong typing for reliability and long-term scalability.",
            iconColor:  "#74C0FC"
        },
        {
            icon: faCss3Alt,
            title: "CSS Modules / Tailwind",
            description: "Clean, scalable styling that keeps your design consistent.",
            iconColor:  "red"
        },
        {
            icon: faTriangleCircleSquare,
            title: "Vercel",
            description: "Lightning-fast hosting with automatic optimization.",
            iconColor:  "black"
        }
    ];

    return (
        <section className={styles.section}>
            <LazyText>
                <h2 className="sectionTitle" style={{color:"#071c3d"}}>Tech Stack We Use</h2>
            </LazyText>

            <ul className={styles.list}>
                {items.map((item, index) => (
                    <li key={index} className={styles.item}>
                        <FontAwesomeIcon icon={item.icon} className={styles.icon} style={{ color: item.iconColor }} />
                        <div>
                            <h3 className={styles.itemTitle}>{item.title}</h3>
                            <p className={styles.itemDescription}>{item.description}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default TechStack;
